import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from "underscore";
import BaseModal from '../Modals/BaseModal';

// SASS Imports
require('./Modal.scss');
require('./LocationListModal.scss');

function mapStateToProps(state) {
    return {
        open: state.modal.isLocationListOpen,
        account: state.modal.locationsFrom
    };
}

class LocationListModal extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const account = this.props.account;
        const sortedLocations = _.sortBy(account.locations, "city");
        let description = account.accountName;

        if (account.company) {
            description += ` (${account.company.standardCompanyName})`;
        }

        return (
            <BaseModal
                isOpen={this.props.open}
                hasCloseButton={true}
                renderWithHeader={true}
                title="All Locations"
                shouldCloseOnOverlayClick={true}
                onRequestClose={() => this.props.closeModal()}
                containerClass="location-list-modal"
            >
                <div className="location-modal">
                    <div className="row locations-label">
                        <div className="col-xs-12">
                            <h4>
                                Locations for <em>{description}</em>
                            </h4>
                        </div>
                    </div>
                    <div className="col-xs-12 locations-list">
                        {sortedLocations.map((location, i) => {
                            return (
                                <div key={"location" + i} className="row location">
                                    <span className="city">
                                        {location.city}, {location.region}{" "}
                                    </span>
                                    <span className="country">
                                        {location.country}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </BaseModal>
        );
    }
}

export default connect(mapStateToProps)(LocationListModal);



// WEBPACK FOOTER //
// ./app/components/Modals/LocationListModal.jsx